import { BookService, ContentService, ObserverService, DavisAlertService } from '@DavisDigital/davisdigitalfrontend.module';
import { ContentModuleTypes, EVENTS } from '@DavisDigital/interfaces';

class BookResourcesModalController {
	
	public book;
	public loading = false; 
	public resourceType;
	public activeVideo: any;
	
	public expanded:any = {}; 
	
	private s3LinkExpireyTime?: number = null;
	
	// @ngInject
	constructor(
		public bookService		: BookService,
		public observerService	: ObserverService,
		public $element,
		private $sce,
		public ModalService,
		private $scope,
		private $http,
		private davisAlertService: DavisAlertService
	){}
	
	public $onInit = () => {
		this.getResources();
		// remove modal from dom after close. This will keep dom memory usage lower, and also stops video playback.
		this.$element.on('hidden.bs.modal', () => this.$element.context.remove());
	}
	
	private getResources = (doAfter?: () => void) => {
		this.loading = true;
		var promises = [];
		let forceUpdate = (this.s3LinkExpireyTime != null && this.s3LinkExpireyTime > 0 && new Date().getTime() > this.s3LinkExpireyTime);
		if (this.book.teacherEdition && this.book.teacherEdition.bookID) {
			promises.push(this.bookService.getResourcesByBookID( this.book.teacherEdition.bookID, this.resourceType, forceUpdate ));
		}
		if (this.book.studentEdition && this.book.studentEdition.bookID) {
			promises.push(this.bookService.getResourcesByBookID( this.book.studentEdition.bookID, this.resourceType, forceUpdate ));
		}
		this.book.bookResourceTypes = [];
		this.book.resources = { brftVideo: [] };
		Promise.all(promises)
			.then( dataResponse => {
				for (let dataResponseIndex = 0; dataResponseIndex < dataResponse.length; dataResponseIndex++) {
					for (let dataIndex = 0; dataIndex < dataResponse[dataResponseIndex].length; dataIndex++) {
						if ( dataResponse[dataResponseIndex][dataIndex].type_systemCode === 'btVideos' ) {
							this.s3LinkExpireyTime = new Date(dataResponse[dataResponseIndex][dataIndex].linkGenerationTime)
														.addMinutes(dataResponse[dataResponseIndex][dataIndex].linkExpiryMinutes)
														.getTime();
							dataResponse[dataResponseIndex][dataIndex].bookResources.forEach(res => {
								let loweredLinkTitle = res.title.toLowerCase();
								if ( this.book.resources.brftVideo.findIndex(v => v.title.toLowerCase() === loweredLinkTitle) < 0 ) {
									this.book.resources.brftVideo.push(res);
								}
							})
						} else {
							this.book.bookResourceTypes.push(dataResponse[dataResponseIndex][dataIndex]);
						}
					}
				}
			})
			.catch( error => console.warn( error ) )
			.finally(()=>{
				this.resetExpanded();
				this.loading = false;
				doAfter && doAfter();
				// Without the following, subsequent modal openings don't display properly.
				this.$scope.$apply();
			});
	}
	
	public playVideo = ( resource: any ) => {
		if (new Date().getTime() > this.s3LinkExpireyTime) {
			const {title, pageNumber} = resource;
			this.getResources(() => {
				let newResource = this.book.resources.brftVideo.find((v: any) => v.title === title && v.pageNumber === pageNumber);
				if (newResource) {
					this.activeVideo = newResource;
					this.activeVideo.videoUrl = this.$sce.trustAsResourceUrl( newResource.s3PathToResourceFile );
				} else {
					this.davisAlertService.error(`Issue loading video "${resource.title}", Please try again.`);
				}
			});
		} else {
			this.activeVideo = resource;
			this.activeVideo.videoUrl = this.$sce.trustAsResourceUrl( resource.s3PathToResourceFile );
		}
	}

	public resetExpanded = () =>{
		for(var i = 0; i < this.book.bookResourceTypes.length; i++){
			// console.log('this.books', this.book.bookResourceTypes[i])
			this.expanded[this.book.bookResourceTypes[i].bookResourceTypeID] = i === 0;
		}
	}
	
	public close = () =>{
		this.ModalService.closeModals();
	}

	public backToListing = () => {
		this.activeVideo = null;
	}
}

class BookResourcesModal {
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		book:"=",
		resourceType:"="
	};

	public controller = BookResourcesModalController;
	public controllerAs = 'bookResourcesModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/book-resources-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { BookResourcesModal };